import React, { forwardRef } from 'react';
import { FormField } from '../FormField.tsx';

export interface CheckboxInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'className'> {
  label?: string;
  error?: string;
  required?: boolean;
  hint?: string;
}

export const CheckboxInput = forwardRef<HTMLInputElement, CheckboxInputProps>(
  ({ label, error, required, hint, id, ...rest }, ref) => (
    <FormField label={undefined} error={error} required={required} hint={hint}>
      <div className="flex items-center gap-2">
        <input
          ref={ref}
          type="checkbox"
          id={id}
          className={`h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 ${error ? 'border-red-500' : ''}`}
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
          {...rest}
        />
        {label && (
          <label htmlFor={id} className="text-sm font-medium text-gray-700 cursor-pointer">
            {label}
            {required && <span className="text-red-500 ml-0.5">*</span>}
          </label>
        )}
      </div>
    </FormField>
  )
);

CheckboxInput.displayName = 'CheckboxInput';
